import { fetchGetSystemConfigAsync, OutputGetSystemConfig } from "@/typescript/Services/Api/GlobalApi";
import { defineStore } from "pinia";

export const useSystemConfigStore = defineStore('SystemConfig', {
    state:()=>({
        config:null as OutputGetSystemConfig | null
    }),
    getters:{
        getConfig:state=>state.config
    },
    actions:{
        /**
         * 获取系统配置
         */
        async GetSystemConfigAsync(){
            const resp = await fetchGetSystemConfigAsync();
            if(resp.CheckIsOk())
                this.config = resp.data!;
            return resp;
        }
    }
});